
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollToTop';

type TElement = Element & {
  style: Record<string, any>;
};

@Component({})
export default class GuidedTourTemplate extends Vue {
  @Prop() activedTour!: string;
  steps: any = [];

  tourName = 'tour';
  stepParamsName = '';

  get step() {
    return this.steps[this.currentStep];
  }

  get currentStep() {
    if (!this.$tours[this.tourName]) return 0;
    return this.$tours[this.tourName].currentStep;
  }

  get callbacks() {
    return {
      onPreviousStep: this.onPreviousStep,
      onNextStep: this.onNextStep,
      onFinish: this.onFinish,
      onSkip: this.onSkip,
      onStart: this.onStart
    };
  }

  get customOptions() {
    return {
      highlight: false,
      labels: {
        // buttonSkip: 'Skip tour',
        buttonNext: 'Next',
        buttonStop: 'Got it!'
      },
      enabledButtons: {
        buttonSkip: false,
        buttonPrevious: false,
        buttonNext: true,
        buttonStop: true
      },
      startTimeout: 1300,
      stopOnTargetNotFound: true,
      useKeyboardNavigation: true,
      enabledNavigationKeys: {
        escape: true,
        arrowRight: true,
        arrowLeft: true
      },
      debug: false
    };
  }

  @Watch('activedTour')
  changedActivedTour() {
    if (this.tourName === this.activedTour) {
      setTimeout(() => {
        this.startTour();
      }, 100);
    }
  }

  startTour() {
    this.$tours[this.tourName].start();
  }

  async onPreviousStep(step: number) {
    if (
      this.steps[this.currentStep] &&
      this.steps[this.currentStep].params.previousStep
    )
      await this.steps[this.currentStep].params.previousStep();
    this.changeStep(step - 1);
  }

  async onNextStep(step: number) {
    if (
      this.steps[this.currentStep] &&
      this.steps[this.currentStep].params.nextStep
    )
      await this.steps[this.currentStep].params.nextStep();
    this.changeStep(step + 1);
  }

  async changeStep(step: any) {
    const currentStep = this.steps[step];

    const {
      target,
      cloneStyle = {
        top: 0,
        height: 0,
        borderRadius: 0,
        border: '',
        alignItems: '',
        padding: '',
        justifyContent: ''
      }
    } = currentStep;

    const element = document.querySelector<TElement>(target);

    if (!element) return;

    const containerFocus = document.getElementById('tour-guide-wrapper');
    const removeClone = document.getElementById('tour-item-clone');
    const removeCloneHightlight = document.getElementById(
      'twism-clone-hightlight'
    );

    if (removeClone) removeClone.remove();
    if (removeCloneHightlight) removeCloneHightlight.remove();

    if (currentStep && currentStep.params && currentStep.params.highlight) {
      Object.assign(element.style, {
        borderRadius: '8px',
        boxShadow: 'none',
        pointerEvents: 'none'
      });

      return;
    }

    if (!element || !containerFocus) {
      return;
    }

    const cloneElement = element.cloneNode(true) as TElement;

    Object.assign(cloneElement, {
      id: 'tour-item-clone',
      [this.stepParamsName]: ''
    });

    const position = element.getBoundingClientRect();

    const top = position.top + window.scrollY + (cloneStyle.top || 0);
    const left = position.left + window.scrollX;
    const width = position.width;
    const height = position.height + (cloneStyle.height || 0);
    const borderRadius = cloneStyle.borderRadius;

    cloneElement.setAttribute(
      'style',
      `
        top: ${top}px;
        left: ${left}px;
        width: ${width}px;
        height: ${height}px;
        margin: 0;
      `
    );

    const highlightElement = document.createElement('div');
    highlightElement.id = 'twism-clone-hightlight';
    highlightElement.setAttribute(
      'style',
      `
        position: fixed;
        top: ${top - 4}px;
        left: ${left - 4}px;
        height: ${height + 8}px;
        width: ${width + 8}px;
        padding: 4px;
        background-color: #FFF;
        border-radius: ${borderRadius};
      `
    );

    containerFocus.appendChild(highlightElement);
    containerFocus.appendChild(cloneElement);
  }

  onHideStep() {
    const containerFocus = document.getElementById('tour-guide-wrapper');
    if (containerFocus) containerFocus.setAttribute('style', 'opacity: 0;');
  }

  onShowStep() {
    const containerFocus = document.getElementById('tour-guide-wrapper');
    if (containerFocus) containerFocus.setAttribute('style', '');
  }

  onSkip() {
    this.onFinish('skip');
  }

  onStart() {
    this.changeStep(0);
  }

  onKeyDownCloseTour() {
    document.onkeydown = ({ key }) => {
      const keysThatCloseTour = ['Escape'];

      if (keysThatCloseTour.includes(key) && this.activedTour) {
        this.onFinish('skip');
      }
    };
  }

  handleScrollToTop() {
    scrollToTop('container-scrollable');
  }

  onFinish(action?: string) {
    eventBus.$emit('closeModal');
    this.$tours[this.tourName].stop();
    this.resetHighlightedSectionAttrs();
    this.handleScrollToTop();
    setTimeout(() => eventBus.$emit('closeGuidedTour'), 100);
    if ((this as any).finish) (this as any).finish();
  }

  getStepId(step: any) {
    const formatedId = step.target.replace(/\[|\]|"/gi, '').replace('=', '-');

    return formatedId;
  }

  resetHighlightedSectionAttrs() {
    for (const step of this.steps) {
      const element = document.querySelector<TElement>(step.target);

      if (!element) continue;

      Object.assign(element.style, {
        pointerEvents: 'auto',
        marginBottom: '0'
      });
    }
  }
  created() {
    this.onKeyDownCloseTour();
  }
}
